<template>
    <!--手机端详情页-->
    <!-- 导航栏 -->
    <ZhaiHead></ZhaiHead>
    <div class="container-fluid zhu py-2">
        <!-- 详情顶部 -->
        <div class="row shengse py-2">
            <div class="px-4">
                <div><span class="Title">{{ details.name }}</span></div>
                <div class="ri mb-1">
                    <small class="bi bi-clock ziti" id="upload-date">
                        <span>&nbsp;{{ details.createTime ? details.createTime.substr(0, 10) : '' }}&nbsp;&nbsp;</span>
                    </small>
                    <small class="bi bi-person-fill ziti" id="collect"><span>&nbsp;匿名</span></small>
                </div>
                <div>
                    <div class="py-1 jiushi"><span class="jiacu">所属地区：</span>&nbsp;{{ details.province }}-{{ details.city }}</div>
                    <div class="py-1 jiushi"><span class="jiacu">小姐年龄：</span>&nbsp;{{ details.age }}</div>
                    <div class="py-1 jiushi"><span class="jiacu">小姐颜值：</span>&nbsp;{{ details.level }}</div>
                    <div class="py-1 jiushi"><span class="jiacu">消费水平：</span>&nbsp;{{ details.price }}</div>
                    <div class="py-1 jiushi"><span class="jiacu">服务项目：</span>&nbsp;{{ details.condition }}</div>
                    <div class="mt-2">
                        <button type="button" @click="toggleCollect" class="btn btn-outline-success bi-bag-heart">{{ isCollected ? '已收藏' : '收藏' }}</button>
                        <button type="button" @click="applyDel" class="btn btn-outline-success bi-trash3">申请删除</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 详情顶部 -->

        <!-- 商品部分 -->
        <div class="row shengse mt-2">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div><i class="shou bi bi-telephone-fill"></i>联系方式</div>
                <div class="iden">
                    <a class="text-decoration-none ruhe zitiyanse" @click="showModalInfo('myModal5')">如何鉴别？</a>
                </div>
            </div>
        </div>
        <!-- 商品部分 -->

        <!-- 如何鉴别 -->
        <div class="row shengse pt-4 pb-0">
            <div class="px-4">
                <div>
                    <div class="alert alert-warning zhuzi" role="alert">凡是有要求路费/定金/保证金/照片验证/视频验证等任何提前付费的行为，千万不要上当。同时也请注意仙人跳，在寻欢前不要露富和带过于贵重随身物品。本站为分享信息并不对寻欢经历负责，碰到有问题的信息，请及时举报给我们删除信息。部分小姐姐较为敏感，所以请在联系对方时不要透露此条信息来源。</div>
                </div>
            </div>
        </div>
        <!-- 如何鉴别 -->

        <!-- 账号详情 -->
        <div class="row shengse pb-4">
            <div class="px-4">
                <template v-if="!isLoggedIn">
                    <div class="py-1 jiushi"><span class="jiacu">QQ：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">微信：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">与你号：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">Telegram：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">电话：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">地址：</span>&nbsp;请先<router-link to="/login" class="login-register-link">登录</router-link>或<router-link to="/register" class="login-register-link">注册</router-link></div>
                </template>
                <template v-else-if="vipExpired">
                    <div class="py-1 jiushi"><span class="jiacu">QQ：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">微信：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">与你号：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">Telegram：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">电话：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                    <div class="py-1 jiushi"><span class="jiacu">地址：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;<router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link></div>
                </template>
                <template v-else>
                    <div v-if="details.account" class="py-1 jiushi"><span class="jiacu">QQ：</span>&nbsp;{{ details.account }}</div>
                    <div v-if="details.remark" class="py-1 jiushi"><span class="jiacu">微信：</span>&nbsp;{{ details.remark }}</div>
                    <div v-if="details.email" class="py-1 jiushi"><span class="jiacu">与你号：</span>&nbsp;{{ details.email }}</div>
                    <div v-if="details.attention" class="py-1 jiushi"><span class="jiacu">Telegram：</span>&nbsp;{{ details.attention }}</div>
                    <div v-if="details.phone" class="py-1 jiushi"><span class="jiacu">电话：</span>&nbsp;{{ details.phone }}</div>
                    <div v-if="details.source" class="py-1 jiushi"><span class="jiacu">地址：</span>&nbsp;{{ details.source }}</div>
                </template>
                <div class="py-1 zhuzi">
                    <span style="color:red">！！！警告：凡是需要预先支付定金、路费的都是诈骗！任何情况下，都不要先给钱！</span>
                </div>
                <div class="mt-2">
                    <button @click="showModalInfo('myModal4')" type="button" class="btn btn-outline-success bi-eye">防骗指南</button>
                    <button @click="showModalInfo('myModal3')" type="button" class="btn btn-outline-success bi-info-circle">信息规则</button>
                </div>
            </div>
        </div>
        <!-- 账号详情 -->

        <!-- 详细介绍 -->
        <div class="row shengse mt-2">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div><i class="shou bi bi-info-circle"></i>详细介绍</div>
            </div>
        </div>
        <!-- 详细介绍 -->

        <!-- 截图部分 -->
        <div v-viewer class="row shengse pb-4 image-container" id="images" ref="gallery">
            <div class="col-6 p-3" v-for="(img, index) in imgList" :key="index">
                <img class="Img w-100 clickable-img" :src="img" :alt="'图片' + (index + 1)">
            </div>
            <div class="px-3 pb-3 mt-3">
                <p class="mb-2 indented" style="font-size:1rem;">
                    {{ details.history }}
                </p>
            </div>
        </div>
        <!-- 截图部分 -->

        <!-- 用户反馈 -->
        <div class="row shengse mt-2">
            <div class="dixian px-4 py-2 mb-3 d-flex justify-content-between">
                <div><i class="shou bi bi-chat-dots-fill"></i>用户反馈</div>
            </div>
            <!-- 反馈列表 -->
            <ZhaiComment v-for="(feedback, index) in feedbackList" :key="index" :data="feedback"></ZhaiComment>
            <div class="fk-ad">
                <button type="button" @click="checkLoginBeforeFeedback" class="btn btn-outline-success mx-auto bi-file-plus-fill">我要反馈</button>
            </div>
        </div>
        <!-- 用户反馈 -->


    <!--本地其他推荐部分-->
    <div class="col-lg-4">
        <div class="bdcard">
            <div class="row rr mt-4">
                <div class="deziti zuo px-4 pb-2 d-flex justify-content-between">
                    <div><i class="shou bi bi-geo-alt-fill"></i>本地其他推荐</div>
                </div>
                <!-- 显示推荐列表 -->
                <div v-if="recommendList.length > 0">
                    <div v-for="(item, index) in recommendList" :key="index" class="no-underline mb-1">
                        <ZhaiCard :data="item" @click="updateRoute(item.id)"></ZhaiCard>
                    </div>
                </div>
                 <!--如果推荐列表为空，显示提示信息 -->
                <div v-else class="text-center text-muted py-4">
                    暂无推荐内容
                </div>
            </div>
        </div>
    </div>
        <!--本地其他推荐部分-->
    </div>

    <!-- 公共底部 -->
    <ZhaiFoot></ZhaiFoot>
    <!-- 公共底部 -->

    <!-- 登录警示 模态框 -->
    <div class="modal fade" id="loginWarningModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 150px;">
            <div class="modal-content">
                <div class="modal-body text-center d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 1.5rem; color: #f16b6b;"></i>
                    <p class="mb-0 ms-2" style="font-size: 0.9rem; color: #f16b6b;">请先登录！</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-smile" style="font-size: 1.5rem; color: #00c26f;"></i>
                    <p class="mb-0 ms-2" style="font-size: 0.9rem; color: #00c26f;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 失败模态框 -->
    <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 200px;">
            <div class="modal-content shake">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 1.5rem; color: #dc3545;"></i>
                    <p class="mb-0 ms-2" style="font-size: 0.9rem; color: #dc3545;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 我要反馈 模态框 -->
    <div class="modal fade" id="myModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">我要反馈</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="ant-modal-body my-2">
                    <form class="myform">
                        <div class="form-group mt-3 px-2">
                            <label style="font-size:1rem;">反馈信息：</label>
                            <input type="text" id="feedback-info" class="form-control motou" v-model="feedbackInfo" name="feedback-info" placeholder="" readonly>
                        </div>
                        <div class="form-group mt-4 px-2">
                            <label style="font-size:1rem;">反馈内容：</label>
                            <textarea  class="form-control " id="content" v-model="feedbackContent" placeholder="平台鼓励反馈真实的体验，请勿提交违背事实的虚假反馈，一经发现将关闭你的评论权限，情节严重的将可能直接封号。"></textarea>
                        </div>
                        <div class="form-group mt-4 px-2">
                            <label style="font-size:1rem;">验证码：</label>
                            <div style="max-width: 300px;">
                                <!-- 这里是包裹验证码输入框的 div -->
                                <CaptchaComponent ref="captchaComponent" @validate-captcha="validateCaptcha"></CaptchaComponent>
                            </div>
                        </div>
                        <div class="form-group mt-3">
                            <div class="text-center mb-3">
                                <button type="button" @click="submitFeedback" class="btn btn-success px-5 toushu feedback-submit-btn">提交</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- 申请删除 模态框 -->
    <div class="modal" id="myModal2">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">申请删除 </h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body">
                    <div class="ant-modal-body motou">
                        <div>本站所有內容来自网友分享，如有内容侵犯到你的隐私、权益或未经你的允许而被他人发布，平台很愿意为你删除，我们同样憎恶出于报复他人的目的而发布的内容。请你提供相关证明材料（比如与帖子内容相符的生活照、或你在其他社交平台发布的链接等，或可以证明联系方式确属于你的证明材料）发邮件至yufenglou123@gmail.com，我们通常会在24小时内处理你的请求，最长不会超过48小时，如果事实逻辑清晰我们将及时为你删除。</div>
                    </div>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success d-block mx-auto toushu" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 信息规则 模态框 -->
    <div class="modal" id="myModal3">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">信息规则</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body motou">
                    <div>部分信息会隐藏账号信息，需要升级VIP会员来享受无限制查看信息的权限。</div>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success d-block mx-auto toushu" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 防骗 模态框 -->
    <div class="modal" id="myModal4">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">防骗指南</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body p-2">
                    <p class="px-3 fb" style="margin-bottom: 0!important;">大家做到以下几点，基本可以有效避免上当受骗。</p>
                    <p class="px-3 fb">防骗第一条：凡是要求预付定金/保证金的，都是骗子！</p>
                    <p class="px-3 motout">
                        一、如果妹子是自己租公寓或者小区里的房子，打听一下房子的租金就可以知道妹子做这个生意的成本大概是多少，依据这个可判断是不是坑。不熟悉的妹子千万不要选择上门，因为没有自己承租地方做这个生意的，大概率都是骗子。
                    </p>
                    <p class="px-3 motout">
                        二、未见面，拒绝提前支付任何费用！！！如车费、定金、安全保证金、预付一半费用、付全款后才见面等各种理由的费用（如给红包发照片，给红包视频，定位到楼下付款，其他人代收款等），切勿因为已开房或其他费用，因小失大，不停给对方打款，越陷越深。
                    </p>
                    <p class="px-3 motout">
                        三、见面后，确认为所预约的人，付费给妹子，或当着妹子的面付给中间人，付费后禁止对方以任何理由离开房间，如有必要离开，请随行，或要求对方退款后，方可离开。
                    </p>
                    <p class="px-3 motout">
                        四、见面后，人照不符的，不满意的，可以拒绝接受服务，或给车费让他走。如是平台认证的帖子，差距大的，不满意的，请立即联系管理员处理。并及时联系平台在线客服。
                    </p>
                    <p class="px-3 motout">
                        五、到店服务的，和描述不一致，直接离开。进店后，问清楚服务项目。确认有服务，选到满意技师，再交费或服务后再交费。模糊介绍服务，为选人先交费，要求办卡才有服务的，请立即离开，并联系平台反馈。
                    </p>
                    <p class="px-3 motout">
                        六、可以提前百度一下对方的联系方式，看是否有人曾被骗。
                    </p>
                    <p class="px-3 motout">
                        七、拒绝支付任何平台旗号的费用。
                    </p>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success d-block mx-auto toushu" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>

    <!-- 如何鉴别 模态框 -->
    <div class="modal" id="myModal5">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title">如何鉴别</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body motou">
                    当您对账号的质量有所顾虑的时候，建议您先购买月度会员，找到适合您的账号并且感觉本站产品的质量可以的情况下再进行VIP升级；
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer mt-2 text-center" style="display: block;">
                    <div class="row">
                        <div class="col-6">
                            <button type="button" class="btn btn-success toushu" data-bs-dismiss="modal">关闭</button>
                        </div>
                        <div class="col-6">
                            <button
                                    type="button"
                                    class="btn btn-success toushu button-large2"
                                    @click="handleNavigateToAvoidFraud">
                                新手防骗指南
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Modal } from 'bootstrap';
    import Viewer from 'viewerjs';
    import 'viewerjs/dist/viewer.css';

    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import ZhaiComment from "../components/ZhaiComment";
    import CaptchaComponent from "../componentspc/CaptchaComponent.vue";
    import ZhaiCard from "../components/ZhaiCard";

    import http from "../utils/http.js";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "MDetails",

        components: {
            ZhaiHead,
            ZhaiFoot,
            ZhaiComment,
            CaptchaComponent,
            ZhaiCard
        },

        data() {
            return {
                details: {
                    id: null,
                    name: '',
                    uploadDate: '',
                    collection: '',
                    province: '',
                    city: '',
                    age: '',
                    price: '',
                    level: '',
                    condition: '',
                    account: '',
                    remark: '',
                    email: '',
                    attention: '',
                    phone: '',
                    source: '',
                    img: '',
                    createTime: '',
                    history: '',
                    presets3: '',
                    presets4: '',
                    presets5: ''
                },

                imgList: [],
                feedbackList: [],
                feedbackInfo: '',
                feedbackContent: '',

                isCollected: false,

                viewerInstance: null,

                recommendList: []
            };
        },

        computed: {
            ...mapGetters(['isLoggedIn', 'getUser']),

            // ✅ VIP 是否过期（保持你原逻辑）
            vipExpired() {
                if (!this.isLoggedIn) return false;
                if (!this.getUser) return false;

                const raw =
                    this.getUser.level_expire_date ??
                    this.getUser.levelExpireDate ??
                    null;

                if (raw === null || raw === undefined) return true;

                // 纯数字：秒/毫秒时间戳都兼容
                if (!Number.isNaN(Number(raw))) {
                    const n = Number(raw);
                    const ms = String(Math.trunc(n)).length === 10 ? n * 1000 : n;
                    return ms < Date.now();
                }

                let s = String(raw).trim();

                // 修复 +0800 → +08:00
                s = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

                // Safari 兼容：空格转 T
                s = s.replace(' ', 'T');

                // 只有日期：当天 23:59:59 才算过期
                if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                    s += 'T23:59:59';
                }

                const d = new Date(s);
                const ms = d.getTime();
                if (Number.isNaN(ms)) {
                    console.warn('VIP expire date parse failed:', raw, 'normalized=', s);
                    return true;
                }

                return ms < Date.now();
            }
        },

        // ✅ created 改成 async，确保刷新时能等到 user 回填（如果 action 支持 await）
        async created() {
            try {
                await this.checkLoginStatus();
            } catch (e) {
                // 不影响页面基础展示
                console.warn('checkLoginStatus failed:', e);
            }

            // 这里不强依赖 watch，首次也主动拉一遍
            this.fetchDetails();
            this.fetchFeedbackList();
            this.checkCollectStatus();
        },

        mounted() {
            this.initViewer();
        },

        watch: {
            imgList() {
                this.initViewer();
            },

            // ✅ 切换详情页（推荐列表点击）时：重置收藏状态 + 重拉数据 + 重新 check
            '$route.query.id': {
                immediate: true,
                handler() {
                    this.isCollected = false;
                    this.fetchDetails();
                    this.fetchFeedbackList();
                    this.checkCollectStatus();
                }
            },

            // ✅ 刷新时 user 异步回填后：补跑一次 check
            'getUser.id': {
                immediate: true,
                handler() {
                    this.checkCollectStatus();
                }
            }
        },

        methods: {
            ...mapActions(['logout', 'checkLoginStatus']),

            // ========== 路由跳转 ==========
            updateRoute(id) {
                this.$router.push({ path: '/details', query: { id } }).then(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                });
            },

            handleNavigateToAvoidFraud() {
                const modal5 = document.getElementById('myModal5');
                if (modal5) {
                    const modalInstance = Modal.getInstance(modal5);
                    if (modalInstance) modalInstance.hide();

                    document.body.classList.remove('modal-open');
                    const backdrops = document.getElementsByClassName('modal-backdrop');
                    while (backdrops.length > 0) {
                        backdrops[0].parentNode.removeChild(backdrops[0]);
                    }
                }

                this.$nextTick(() => {
                    this.$router.push('/avoidFraud');
                });
            },

            // ========== 数据获取 ==========
            fetchDetails() {
                const id = this.$route.query.id;
                if (!id) return;

                http.get(`/platform/frontEnd/details?id=${id}`)
                    .then(res => {
                        if (res.data.status === 1) {
                            this.details = res.data.data || {};
                            this.feedbackInfo = this.details.name || '';

                            // ✅ 图片列表合并
                            this.imgList = [
                                ...(this.details.img ? this.details.img.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets3 ? this.details.presets3.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets4 ? this.details.presets4.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets5 ? this.details.presets5.split(',').map(v => v.trim()) : [])
                            ];

                            // ✅ 详情回来后再拉推荐列表（避免 created 时 details.id 为空）
                            this.fetchRecommendList(this.details.id);

                            // ✅ 详情回来后也再 check 一次（兜底）
                            this.checkCollectStatus();
                        } else {
                            console.error('获取详情数据失败:', res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.error('获取详情数据时出错:', err);
                    });
            },

            fetchFeedbackList() {
                const id = this.$route.query.id;
                if (!id) return;

                http.get(`/platform/frontEnd/feedbackList?bizType=1&bizId=${id}`)
                    .then(res => {
                        if (res.data.status === 1) {
                            this.feedbackList = res.data.data || [];
                        } else {
                            console.error('获取用户反馈数据失败:', res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.error('获取用户反馈数据时出错:', err);
                    });
            },

            fetchRecommendList(id) {
                const accountId = Number(id || this.$route.query.id);
                if (!accountId) return;

                http.get(`/platform/frontEnd/recommendList?id=${accountId}`)
                    .then(res => {
                        if (res.data.status === 1) {
                            this.recommendList = res.data.data || [];
                        } else {
                            console.error('获取推荐列表失败:', res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.error('获取推荐列表时出错:', err);
                    });
            },

            // ========== 收藏逻辑（关键修复：全部 Number 化）==========
            checkCollectStatus() {
                if (!this.isLoggedIn || !this.getUser?.id) return;

                const accountId = Number(this.details.id || this.$route.query.id);
                const userId = Number(this.getUser.id);

                if (!accountId || !userId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action: 'check'
                };

                http.post('/platform/frontEnd/handleCollect', postData)
                    .then(res => {
                        if (res.data && res.data.status === 1) {
                            this.isCollected = !!res.data.data.isCollected;
                        } else {
                            console.error('检查收藏状态失败:', res.data?.msg);
                        }
                    })
                    .catch(err => {
                        console.error('检查收藏状态时出错:', err);
                    });
            },

            toggleCollect() {
                if (!this.isLoggedIn) {
                    this.showLoginWarningModal();
                    return;
                }

                const accountId = Number(this.details.id || this.$route.query.id);
                const userId = Number(this.getUser.id);
                const action = this.isCollected ? 'cancel' : 'collect';

                if (!accountId || !userId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action
                };

                http.post('/platform/frontEnd/handleCollect', postData)
                    .then(res => {
                        if (res.data && res.data.status === 1) {
                            this.isCollected = !this.isCollected;
                            this.showModal(
                                'successModal',
                                this.isCollected ? '收藏成功' : '取消收藏成功',
                                'bi bi-emoji-smile',
                                '#00c26f'
                            );
                        } else {
                            this.showModal(
                                'errorModal',
                                action === 'collect' ? '收藏失败' : '取消收藏失败',
                                'bi bi-emoji-frown',
                                '#dc3545'
                            );
                        }
                    })
                    .catch(err => {
                        console.error(`${action === 'collect' ? '收藏' : '取消收藏'}请求错误:`, err);
                        this.showModal('errorModal', '请求发生错误，请稍后再试', 'bi bi-emoji-frown', '#dc3545');
                    });
            },

            // ========== Modal ==========
            showLoginWarningModal() {
                const el = document.getElementById('loginWarningModal');
                if (!el) return;

                const modal = new Modal(el);

                // 如果已经打开，就只抖动
                if (el.classList.contains('show')) {
                    el.classList.remove('shake-animation');
                    void el.offsetWidth;
                    el.classList.add('shake-animation');
                    return;
                }

                el.classList.add('shake-animation');
                modal.show();

                setTimeout(() => modal.hide(), 2000);
                setTimeout(() => el.classList.remove('shake-animation'), 600);
            },

            showModal(modalId, message, iconClass, textColor) {
                const el = document.getElementById(modalId);
                if (!el) return;

                const modalBodyP = el.querySelector('.modal-body p');
                const icon = el.querySelector('.bi');

                if (icon) {
                    icon.className = iconClass;
                    icon.style.color = textColor;
                }
                if (modalBodyP) {
                    modalBodyP.textContent = message;
                }

                const modal = new Modal(el);
                el.classList.add('shake-animation');
                modal.show();

                setTimeout(() => {
                    el.classList.remove('shake-animation');
                    modal.hide();
                }, 3000);
            },

            applyDel() {
                const el = document.getElementById('myModal2');
                if (!el) return;
                new Modal(el).show();
            },

            showModalInfo(modalId) {
                const el = document.getElementById(modalId);
                if (!el) return;
                new Modal(el).show();
            },

            // ========== 反馈 ==========
            checkLoginBeforeFeedback() {
                const warningEl = document.getElementById('loginWarningModal');
                const warningModal = warningEl ? new Modal(warningEl) : null;

                if (this.isLoggedIn) {
                    const feedbackEl = document.getElementById('myModal');
                    if (feedbackEl) new Modal(feedbackEl).show();
                    return;
                }

                if (!warningEl || !warningModal) return;

                if (warningEl.classList.contains('show')) {
                    warningEl.classList.remove('shake-animation');
                    void warningEl.offsetWidth;
                    warningEl.classList.add('shake-animation');
                } else {
                    warningEl.classList.add('shake-animation');
                    warningModal.show();
                    setTimeout(() => warningModal.hide(), 2000);
                    setTimeout(() => warningEl.classList.remove('shake-animation'), 600);
                }
            },

            submitFeedback() {
                const codeInput = document.querySelector('.captcha-input');
                const enteredCaptcha = codeInput ? codeInput.value.trim() : '';
                const actualCaptcha = this.$refs.captchaComponent?.captchaText;

                if (!this.feedbackContent || !this.feedbackContent.trim()) {
                    this.showModal('errorModal', '必填项不可为空！', 'bi bi-emoji-frown', '#dc3545');
                    return;
                }

                if (!enteredCaptcha) {
                    this.showModal('errorModal', '必填项不可为空！', 'bi bi-emoji-frown', '#dc3545');
                    return;
                }

                if (enteredCaptcha !== actualCaptcha) {
                    this.showModal('errorModal', '验证码错误！', 'bi bi-emoji-frown', '#dc3545');
                    this.$refs.captchaComponent?.generateCaptcha?.();
                    return;
                }

                const feedbackData = {
                    message: this.feedbackContent,
                    accountid: Number(this.details.id || this.$route.query.id),
                    userid: Number(this.getUser.id),
                    username: this.getUser.username,
                    userlevel: this.getUser.level
                };

                http.post('/platform/frontEnd/feedback', feedbackData, false, true)
                    .then(res => {
                        if (res.data.status === 1) {
                            this.showModal('successModal', '反馈提交成功', 'bi bi-emoji-smile', '#00c26f');

                            const feedbackModalEl = document.getElementById('myModal');
                            const feedbackModal = feedbackModalEl ? Modal.getInstance(feedbackModalEl) : null;
                            if (feedbackModal) feedbackModal.hide();
                        } else {
                            this.showModal('errorModal', `反馈提交失败: ${res.data.msg}`, 'bi bi-emoji-frown', '#dc3545');
                        }
                    })
                    .catch(err => {
                        const errorMsg = err?.response?.data?.msg || '请求发生错误，请稍后再试';
                        this.showModal('errorModal', `提交反馈时出错: ${errorMsg}`, 'bi bi-emoji-frown', '#dc3545');
                    });
            },

            validateCaptcha(isValid) {
                if (!isValid) alert('图形验证码输入不正确！');
            },

            // ========== 图片查看 ==========
            initViewer() {
                this.$nextTick(() => {
                    const gallery = this.$refs.gallery;
                    if (!gallery) return;

                    if (this.viewerInstance) {
                        this.viewerInstance.destroy();
                        this.viewerInstance = null;
                    }

                    this.viewerInstance = new Viewer(gallery, {
                        url: 'src',
                        navbar: true,
                        toolbar: true,
                        tooltip: true,
                        title: true
                    });
                });
            }
        },

        beforeUnmount() {
            if (this.viewerInstance) {
                this.viewerInstance.destroy();
                this.viewerInstance = null;
            }
        }
    };
</script>



<style scoped>
    /* 确保模态框显示在导航栏之上 */
    #myModal4 {
        z-index: 1055 !important; /* 确保模态框位于导航栏之上 */
        overflow-y: auto; /* 启用模态框内部滚动 */
    }

    /* 模态框内容布局 */
    #myModal4 .modal-content {
        height: 90vh; /* 限制模态框高度为视口的 90% */
        display: flex;
        flex-direction: column; /* 将模态框内容垂直分布 */
    }

    /* 模态框整体居中并限制宽度 */
    #myModal4 .modal-dialog {
        max-width: 90%; /* 适应手机屏幕宽度 */
        margin: 1rem auto; /* 增加顶部和底部的间距 */
    }

    /* 模态框内容部分可滚动 */
    #myModal4 .modal-body {
        overflow-y: auto; /* 内容区域可滚动 */
        flex-grow: 1; /* 让内容区域占据剩余空间 */
        padding: 1rem; /* 设置内边距 */
        font-size: 0.9rem; /* 调整字体大小 */
        line-height: 1.5; /* 增加行高 */
    }

    /* 模态框底部关闭按钮固定 */
    #myModal4 .modal-footer {
        position: sticky; /* 固定底部按钮 */
        bottom: 0;
        background-color: #fff; /* 确保按钮区域有背景色 */
        z-index: 10; /* 确保按钮始终在内容上方 */
        padding: 0.5rem; /* 增加按钮区域内边距 */
        text-align: center; /* 按钮居中对齐 */
    }

    .fb{
        font-weight: bold;
        color: #00c26f

    }
    .motou{
        font-size: 1rem!important;
    }
    .motout{
        font-size: 1rem!important;
    }
    /* 保持边框颜色和字体颜色为#00c26f */
    .btn-outline-success {
        color: #00c26f;
        border-color: #00c26f;
        background-color: transparent; /* 确保背景色为透明 */
        padding: 0.3rem 0.7rem !important;
        font-size: 0.9rem !important;
    }

    /* 覆盖 hover 状态 */
    .btn-outline-success:hover {
        color: #00c26f;
        background-color: transparent;
        border-color: #00c26f;
        padding: 0.3rem 0.7rem !important;
        font-size: 0.85rem !important;
    }

    /* 覆盖 active 状态 */
    .btn-outline-success:active,
    .btn-outline-success.active,
    .btn-outline-success:focus,
    .btn-outline-success:not(:disabled):not(.disabled):active,
    .btn-outline-success:not(:disabled):not(.disabled).active,
    .show > .btn-outline-success.dropdown-toggle {
        color: #00c26f;
        background-color: transparent;
        border-color: #00c26f;
        box-shadow: none; /* 去掉按钮点击后的阴影效果 */
        padding: 0.3rem 0.7rem !important;
        font-size: 0.9rem !important;
    }

    /* 调整按钮样式 */
    .toushu,
    .feedback-submit-btn {
        background-color: #00c26f !important;
        border: none !important;
        padding: 0.3rem 0.7rem !important;
        font-size: 1rem !important;
    }

    /* hover、active 和 focus 状态的按钮样式 */
    .toushu:hover,
    .toushu:active,
    .toushu.active,
    .toushu:focus,
    .feedback-submit-btn:hover,
    .feedback-submit-btn:active,
    .feedback-submit-btn.active,
    .feedback-submit-btn:focus {
        padding: 0.3rem 0.7rem !important;
        font-size: 0.85rem !important;
    }

    .shou {
        font-style: normal;
    }

    .bi-telephone-fill {
        font-size: 14px;
    }

    .text-primary {
        color: #2b2b37!important;
    }

    .zhuzi {
        font-size: small;
    }

    .jiushi {
        font-size: 90%;
    }

    .indented {
        text-indent: 2em;
    }

    .fk-ad {
        text-align: center;
        padding-bottom: 2rem;
    }

    .bi-bag-heart {
        margin-right: 5px;
    }

    .bi-eye {
        margin-right: 5px;
    }

    .modal {
        margin-top: 4rem !important;
    }

    .ruhe {
        font-size: 0.8rem;
    }

    .zhu {
        margin-top: 80px;
    }

    .viewer-canvas img {
        display: block;
        max-width: 100%;
    }

    /* 登录和注册链接样式 */
    .login-register-link {
        color: #18b371 !important;
        font-size: inherit;
        text-decoration: none;
        padding: 0;
    }

    @keyframes shake {
        0%, 100% {
            transform: translateX(0);
        }
        10%, 30%, 50%, 70%, 90% {
            transform: translateX(-5px);
        }
        20%, 40%, 60%, 80% {
            transform: translateX(5px);
        }
    }

    .shake-animation {
        animation: shake 0.5s;
    }

    /* 添加自定义样式确保模态框居中 */
    #loginWarningModal .modal-dialog,
    #successModal .modal-dialog,
    #errorModal .modal-dialog {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    /* 调整模态框的样式 */
    #loginWarningModal .modal-body,
    #successModal .modal-body,
    #errorModal .modal-body {
        padding: 0.25rem 0.5rem !important; /* 调整内边距 */
    }

    #loginWarningModal .modal-body p,
    #successModal .modal-body p,
    #errorModal .modal-body p {
        font-size: 0.9rem; /* 调整字体大小 */
    }

    #loginWarningModal .modal-body i,
    #successModal .modal-body i,
    #errorModal .modal-body i {
        font-size: 1.5rem; /* 调整图标大小 */
    }
    .form-control{
        font-size: 0.9rem;
    }
    /* 调整模态框的 z-index */
    #myModal {
        z-index: 1051; /* 确保反馈模态框在最高层 */
    }

    #loginWarningModal,
    #successModal,
    #errorModal {
        z-index: 1052; /* 确保其他模态框在反馈模态框之上 */
    }
    .upgrade-vip-link {
        color: #00c26f !important;
        font-size: inherit;
        text-decoration: none;
        cursor: pointer;
    }
    .upgrade-vip-link:hover {
        text-decoration: underline;
    }
</style>

